<template>
  <div>
    <div class="tw-flex tw-flex-col lg:tw-flex-row">
      <div
        class="lg:tw-w-1/2 tw-text-left tw-px-4 tw-py-6 lg:tw-p-6 tw-order-last lg:tw-order-first"
      >
        <div class="sm:tw-max-w-md lg:tw-max-w-[413px] tw-mx-auto lg:tw-mt-20">
          <h1 class="tw-text-5xl tw-text-brand-orange tw-mb-4">
            {{ data.hero.headline }}
          </h1>
          <div
            v-html="data.hero.body"
            class="tw-text-base tw-leading-loose tw-text-gray-500"
          ></div>
          <a
            :href="data.hero.link.url"
            class="hover:tw-text-white tw-bg-brand-orange tw-text-white tw-w-full tw-px-5 tw-py-2.5 tw-rounded-full tw-inline-block tw-mt-4 tw-text-center"
            >{{ data.hero.link.title }}
          </a>
        </div>
      </div>
      <div
        class="lg:tw-w-1/2 tw-h-[200px] sm:tw-h-[300px] lg:tw-h-auto lg:tw-max-h-[600px]"
      >
        <img
          :src="data.hero.image.url"
          :alt="data.secondary_hero.image.alt"
          class="tw-object-cover tw-w-full tw-h-full tw-object-bottom"
        />
      </div>
    </div>

    <!-- stats -->
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="tw-bg-brand-orange tw-mt-24">
      <div
        class="tw-mx-auto tw-max-w-7xl tw-py-12 tw-px-4 sm:tw-py-16 sm:tw-px-6 lg:tw-px-8 lg:tw-py-20"
      >
        <dl
          class="tw-text-center sm:tw-mx-auto sm:tw-flex sm:tw-max-w-3xl sm:tw-justify-center sm:tw-space-x-16 tw-space-y-16 sm:tw-space-y-0"
        >
          <Stat
            v-for="(stat, i) in data.stats"
            :stat="stat"
            :index="i"
            :value="stat.value"
            :displayValue="0"
          />
        </dl>
      </div>
    </div>

    <!-- /stats -->

    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-mt-20 lg:tw-mt-0">
      <div
        class="lg:tw-w-1/2 flex items-center justify-center tw-mb-4 lg:tw-mb-0 tw-px-4"
      >
        <img
          :src="data.secondary_hero.image.url"
          :alt="data.secondary_hero.image.alt"
          class="tw-max-w-[500px] tw-w-full"
        />
      </div>
      <div class="lg:tw-w-1/2 tw-text-left tw-px-4 tw-py-6 lg:tw-p-6">
        <div class="sm:tw-max-w-lg lg:tw-max-w-xl tw-mx-auto lg:tw-mt-20">
          <h1 class="tw-text-3xl tw-text-brand-orange">
            {{ data.secondary_hero.title }}
          </h1>
          <div v-html="data.secondary_hero.body"></div>
          <a
            v-if="data.secondary_hero.button"
            :href="data.secondary_hero.button.url"
            class="tw-bg-white tw-border-2 tw-border-solid tw-border-brand-orange tw-text-brand-orange tw-w-full tw-px-5 tw-py-2.5 tw-rounded-full tw-inline-block tw-mt-8 tw-text-center"
            >{{ data.secondary_hero.button.title }}
          </a>
        </div>
      </div>
    </div>

    <div class="container tw-mx-auto tw-my-20">
      <div class="sm:tw-flex tw-flex-wrap tw--mx-2">
        <div
          v-for="card in data.cards"
          class="sm:tw-w-1/2 lg:tw-w-1/3 tw-px-2 tw-flex tw-items-stretch"
        >
          <article
            class="tw-flex-1 tw-rounded-lg tw-transition hover:tw-shadow-xl tw-shadow tw-transition tw-duration-200 tw-transition-shadow tw-flex tw-flex-col tw-mb-8"
          >
            <img
              :src="card.image.url"
              class="tw-w-full tw-rounded-t-lg tw-object-cover tw-position-center tw-h-48 tw-group"
            />
            <div class="tw-px-8 tw-py-6 tw-flex tw-flex-col tw-flex-grow">
              <h4 class="tw-text-left tw-text-lg tw-text-gray-900 tw-mb-4">
                {{ card.headline }}
              </h4>
              <p
                class="tw-text-left tw-m-0 tw-text-sm tw-text-gray-500 tw-pb-8"
              >
                {{ card.body }}
              </p>
              <a :href="card.link.url" class="tw-mt-auto tw-text-left">
                <p
                  class="tw-border-none tw-text-base tw-px-0 tw-font-bold focus:tw-text-blue-600 tw-bottom-0 tw-inline-block tw-text-orange-600 tw-rounded-full tw-py-2 tw-transition tw-duration-300 tw-transform"
                >
                  {{ card.link.title }}
                </p>
              </a>
            </div>
          </article>
        </div>
      </div>
    </div>

    <div class="tw-mx-auto tw-max-w-4xl tw-pt-12 tw-pb-24 tw-px-4">
      <h2 class="tw-mb-4">{{ data.call_to_action.headline }}</h2>
      <div v-html="data.call_to_action.body"></div>
      <a
        v-if="data.call_to_action.button"
        :href="data.call_to_action.button.url"
        class="tw-bg-brand-orange tw-text-white tw-px-5 tw-py-2.5 tw-rounded-full tw-inline-block tw-mt-4 tw-text-center"
        >{{ data.call_to_action.button.title }}</a
      >
    </div>
  </div>
</template>
<script>
import gsap from 'gsap'
import Stat from '~/components/Stat.vue'
import kids from '~/assets/kids.jpg'
import kids2 from '~/assets/kids2.png'
export default {
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  components: {
    Stat,
  },
  data() {
    return {
      kids,
      kids2,
    }
  },
}
</script>
